<template>
  <div class="page page-details page-material-details">
    <div class="material_preview_dialog_left">
      <div class="viewcontainer">
        <!--<img :src="materialViewDialog.url" alt="加载失败" v-if="materialViewDialog.type==1"/>-->
        <div v-if="materialViewDialog.type == 1" class="img_wrap">
          <viewer :images="[materialViewDialog.url]">
            <img
              v-for="(src, i) in [materialViewDialog.url]"
              :src="src"
              :key="i"
            />
          </viewer>
        </div>
        <div
          v-if="materialViewDialog.type == 2"
          :class="'pdf_wrap ' + pdfEnlargStyle + ' ' + pageStyle"
          :style="'height:'+(pdfEnlargStyle==''?(windowHeight-30):(windowHeight))+'px'"
        >
          <!--style="min-height: 430px; background: #fff;"-->
          <pdf
            ref="pdf"
            class="myPDF"
            v-loading="loading"
            :src="materialViewDialog.url"
            :page="pageNum"
            :rotate="pageRotate"
            @password="password"
            @progress="loadedRatio = $event"
            @page-loaded="pageLoaded($event)"
            @num-pages="pageTotalNum = $event"
            @error="pdfError($event)"
            @link-clicked="page = $event"
          ></pdf>
          <i
            class="el-icon-arrow-left btn-def btn-pre"
            @click.stop="prePage"
            @dblclick.stop=""
          ></i>
          <i
            class="el-icon-arrow-right btn-def btn-next"
            @click.stop="nextPage"
            @dblclick.stop=""
          ></i>
          <span class="pdfCurrentPage">{{ pageNum }}/{{ pageTotalNum }}</span>
          <div class="operating_btn">
            <div>
              <i
                class="el-icon-zoom-in"
                @click="pdfEnlargeBtn"
                @dblclick.stop=""
                v-if="pdfEnlargeSign == 1"
              ></i>
              <i
                class="el-icon-zoom-out"
                @click="pdfNarrowBtn"
                @dblclick.stop=""
                v-if="pdfEnlargeSign == 2"
              ></i>
            </div>
            <div></div>
          </div>
        </div>
        <div v-if="materialViewDialog.type == 3" class="video_wrap">
          <audio
            class="audio"
            :src="materialViewDialog.url"
            controls="controls"
          ></audio>
        </div>
        <div v-if="materialViewDialog.type == 4" class="video_wrap">
          <video
            ref="video"
            id="video1"
            class="video"
            controls
            controlsList="nodownload"
            muted="muted"
            preload="auto"
            data-setup='{"example_option":true}'
            height="500"
          >
            <!--      width="500"
            height="280"-->
            <source
              id="sourceBox"
              :src="materialViewDialog.url"
              type="video/mp4"
              class="video"
            />
            <p class="vjs-no-js">不支持播放</p>
          </video>
        </div>
      </div>
    </div>
    <div class="material_preview_dialog_right">
      <ul>
        <li>
          <p>素材名称：</p>
          <p>{{ materialForm.materialName }}</p>
        </li>
        <li>
          <p>分类：</p>
          <p>{{ materialForm.materialsort }}</p>
        </li>
        <li>
          <p>上传人：</p>
          <p>{{ materialForm.createUseStr }}</p>
        </li>
        <li>
          <p>上传时间：</p>
          <p>{{ materialForm.uploadTime }}</p>
        </li>
      </ul>
      <el-button @click="handleGoBack">返 回</el-button>
    </div>
  </div>
</template>

<script>
import * as api from '../../../api/sourceApi'
import bus from "../../../vendor/eventbus.js";
import { mapState } from "vuex";
import pdf from "vue-pdf";

export default {
  name: "materialDetails",
  data() {
    return {
      materialViewDialog: {
        type: 0,
        url: "",
      },
      pdfEnlargStyle: "",
      pageStyle: "",
      pageNum: 1,
      pageRotate: 0,
      loading: false,
      pageTotalNum: 1,
      pdfEnlargeSign: 1,
      postDirectory: {
        resProgress: 1, //这条资源最后一次学习的时间
        totalResNum: 0, //总资源数
      },
      materialForm: {
        id: "",
        materialName: "",
        materialsort: "",
        materialPic: "",
        uploader: "",
        uploadTime: "",
      },
      imageUrl: require("../../../assets/image/sources/wenjianjia.png"),
      windowHeight: window.innerHeight
    };
  },
  components: {
    pdf,
  },
  computed: {
    // ...mapState({
    //   floaterTag: (state) => state.app.floaterOpened,
    // }),
  },
  created() {

  },
  mounted() {
      // console.log(this.detailData,"xxxxxxxxxx")
    // if (!this.floaterTag) {
    //   console.log("1111111111111")
      this.init(this.detailData); // 初始化
      // console.log("222222222222")
    // }
  },
    props:{
        detailData:{
            type:Object
        }
    },
  methods: {
    init(data) {

      if (data) {
        //   console.log(data,"22222222211111111111111111111111111111")
        // if (data.type == 5 && data.newAttaUrl) {
        //   this.handlegetZip(data.newAttaUrl);
        // }else
          if (data.type != 5 && data.id) {
          this.handleGetMaterialDetail(data.id, data.type);
        }
      }
    },

    handleGetMaterialDetail(id, type) {
      api
        .getMaterialDetail({ id }, {})
        .then((res) => {
          // console.log(res);
          if (res.code == 0) {
            this.materialForm.materialUpload = "success";
            this.materialForm.id = id;
            this.materialForm.materialName = res.data.name;
            this.materialForm.materialsort = res.data.classify;
            this.materialViewDialog.url = res.data.newAttaUrl;
            this.materialForm.createUseStr = res.data.createUseStr;
            this.materialForm.uploadTime = res.data.createTimeStr;
            //修改显示素材名称
            // if (this.materialObjData) {
            //   this.selectedOptions = this.materialObjData.arrIds;
            // }

            if (type && type == 1) {
              this.materialViewDialog.type = 1;
              this.imageUrl = require("../../../assets/image/sources/picture.png");
            } else if (type && type == 2) {
              this.pageNum = 1;
              this.materialViewDialog.type = 2;
              this.imageUrl = require("../../../assets/image/sources/wenjian.png");
            } else if (type && type == 3) {
              this.materialViewDialog.type = 3;
              this.imageUrl = require("../../../assets/image/sources/yinpin.png");
            } else if (type && type == 4) {
              if (this.$refs.video && this.$refs.video.paused) {
                this.$refs.video.play();
              }
              this.materialViewDialog.type = 4;
              this.imageUrl = require("../../../assets/image/sources/video.png");
            } else if (type && type == 5) {
              this.imageUrl = require("../../../assets/image/sources/zip.png");
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    password(updatePassword) {
      updatePassword(prompt('password is "123456"'));
    },
    pageLoaded() {
      this.loading = false;
    },
    pdfError(error) {
      console.error(error);
    },
    prePage() {
      let p = this.pageNum;
      p = p > 1 ? p - 1 : this.pageTotalNum;
      this.pageNum = p;
      this.postDirectory.resProgress = this.pageNum;
    },
    nextPage() {
      let p = this.pageNum;
      p = p < this.pageTotalNum ? p + 1 : 1;
      this.pageNum = p;
      this.postDirectory.resProgress = this.pageNum;
    },
    pdfEnlargeBtn() {
      this.pdfEnlargeSign = 2;
      this.pdfEnlargStyle = "pdf_enlarge";
      this.pageStyle = "page_style";
    },
    pdfNarrowBtn() {
      this.pdfEnlargeSign = 1;
      this.pdfEnlargStyle = "";
      this.pageStyle = "";
    },

      clearField(){
          this.materialViewDialog.type=0;
          this.materialViewDialog.url="";

      },

    //返回上一页
    handleGoBack() {
        this.$emit("closeDrawe");
      // 返回，如果是pc，修改vuex，如果是移动端，go(-1)。
      // if (this.floaterTag) {
      //   this.$store.commit("CLOSE_FLOATER");
      // } else {
      //   this.$router.go(-1);
      // }
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss">
/*@import "../../scss/variables";*/
/*@import "../../scss/mixins";*/

.page-material-details {
  /*width: 65% !important;*/
  height: 100%;
  display: flex;
  .material_preview_dialog {
    .el-dialog__header {
      width: 832px;
      height: 48px;
      background: rgba(237, 244, 255, 1);
      border-radius: 8px 8px 0px 0px;
      padding: 20px 0 0 0;
      box-sizing: border-box;
      line-height: 48px;

      .el-dialog__title {
        display: block;
        font-size: 14px;
        font-weight: 400;
        color: rgba(83, 151, 247, 1);
        border-left: 2px solid #5397f7;
        line-height: 10px;
        padding-left: 3px;
        margin-left: 16px;
      }

      .el-dialog__headerbtn {
        top: 16px;
      }
    }

    /deep/ .el-dialog__body {
      padding: 0;
      overflow: hidden;
      border-radius: 0 0 8px 8px;
      margin: 0;
      display: flex;
    }
  }
  .material_preview_dialog_left {
    flex: 0.65;
    margin: 15px 0;
    border-radius: 8px;
    /*width: 560px;*/
    /*height: 462px;*/
    background: #eeeeee;
    /*box-sizing: border-box;*/
    /*position: relative;*/
    /*float: left;*/

    .viewcontainer {
      position: relative;
      height: 100%;
      /*width: 560px;*/
      /*height: 430px;*/
      overflow-x: hidden;
      /*overflow-y: auto;*/
      .img_wrap {
        /*width: 560px;*/
        /*height: 430px;*/
        height: 100%;
        position: relative;

        img {
          max-width: 100%;
          max-height: 100%;
          position: absolute;
          left: 0;
          top: 0;
          bottom: 0;
          right: 0;
          margin: auto;
        }
      }
      .video_wrap {
        width: 100%;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        .video {
          width: 100%;
          min-width: 480px;
        }
      }
    }

    .pdf_wrap {
      position: relative;
      background: #fff;
      overflow-y: auto;
      /*top: 50%;*/
      /* transform: translateY(-50%);*/
      .myPDF {
        height: 100%;
        overflow: scroll;
        .annotationLayer {
          transform: none !important;
        }
      }
      .btn-def {
        /*padding: 5px 5px;*/
        position: absolute;
        top: 0;
        bottom: 0;
        margin: auto;
        font-size: 16px;
        width: 28px;
        height: 28px;
        background: rgba(0, 0, 0, 0.3);
        text-align: center;
        line-height: 28px;
        border-radius: 50%;
        cursor: pointer;
      }

      .btn-pre {
        left: 10px;
      }

      .btn-next {
        right: 10px;
      }

      .pdfCurrentPage {
        /*width: 98%;*/
        text-align: center;
        position: absolute;
        bottom: 0px;
        left: 0;
        right: 0;
        margin: auto;
        height: 30px;
        line-height: 30px;
        background: #eee;
        color: #333;
      }

      .operating_btn {
        position: absolute;
        bottom: 2px;
        right: 10px;
        display: flex;
        align-items: center;

        i {
          margin-left: 10px;
          text-align: center;
          font-size: 28px;
          color: #5397f7;
          cursor: pointer;
        }

        span {
          border: 1px solid #ccc;
          background: #ccc;
        }
      }
    }

    .pdf_enlarge {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      overflow: auto;
    }

    .page_style {
      .btn-def {
        position: fixed;
      }

      .btn-pre {
        left: 10px;
      }

      .btn-next {
        right: 10px;
      }

      .pdfCurrentPage {
        position: fixed;
        bottom: 10px;
        left: 0;
        right: 0;
        margin: auto;
        line-height: 30px;
        width: 80px;
        background: rgba(0, 0, 0, 0.3);
        color: rgba(0, 0, 0, 1);
        border-radius: 8px;
      }

      .operating_btn {
        position: fixed;
        bottom: 10px;
        right: 20px;
      }
    }
  }
  .material_preview_dialog_right {
    flex: 0.35;
    /*width: auto;*/
    /*height: 462px;*/
    background: #fff;
    /*text-align: center;*/
    /*overflow-y: auto;*/
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    /*padding: 20px 0;*/
    /*box-sizing: border-box;*/

    ul {
      li {
        /*display: flex;*/
        margin-top: 16px;
        /*justify-content: center;*/
        p{
          line-height: 20px;
        }
        p:first-child {
          font-size: 14px;
          font-weight: 400;
          color: #333333;
          /*width: 80px;*/
          /*text-align: right;*/
        }

        p:last-child {
          font-size: 14px;
          font-weight: 400;
          color: #999999;
          /*min-width: 140px;*/
          text-align: left;
        }
      }
    }

    button {
      width: 79px;
      height: 32px;
      border: 1px solid #5397f7;
      background: #fff;
      border-radius: 4px;
      color: #5397f7;
      padding: 5px 18px;
      margin-top: 100px;

      &:hover {
        width: 79px;
        height: 32px;
        border: 1px solid #5397f7;
        background: #fff;
        border-radius: 4px;
        color: #fff;
        padding: 5px 18px;
        margin-top: 100px;
        background: #409eff;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/course/materialDetails.vue